import React from 'react';
import {
  HiOutlineBriefcase,
  HiOutlineCalendarDays,
  HiOutlineBanknotes,
  HiOutlineMapPin,
  HiOutlineBuildingOffice2,
} from 'react-icons/hi2';

const CandidateCard = ({ candidat, matchPercentage, summary }) => {
  const getBadgeColor = (percent) => {
    if (percent >= 75) return 'bg-green-500 text-white';
    if (percent >= 50) return 'bg-yellow-500 text-white';
    return 'bg-red-500 text-white';
  };

  return (
    <div className="bg-pro-dark-surface rounded-lg p-6 border border-pro-dark-border transform hover:-translate-y-1 transition-transform duration-300 flex flex-col justify-between">
      <div>
        <div className="flex justify-between items-start">
          <div>
            <h3 className="text-lg font-bold text-pro-dark-text-primary">{candidat.prenom} {candidat.nom}</h3>
            <p className="text-sm text-pro-dark-text-secondary">{candidat.posteActuel}</p>
          </div>
          <div className={`px-3 py-1 text-sm font-bold rounded-full ${getBadgeColor(matchPercentage)}`}>
            {matchPercentage}%
          </div>
        </div>
        <p className="mt-4 text-sm text-pro-dark-text-secondary italic">"{summary}"</p>
      </div>
      <div className="mt-4 grid grid-cols-2 gap-2 text-xs text-pro-dark-text-secondary border-t border-pro-dark-border pt-4">
        <span className="flex items-center gap-1"><HiOutlineBriefcase /> {candidat.xp || 'N/A'} ans d'XP</span>
        <span className="flex items-center gap-1"><HiOutlineCalendarDays /> Dispo: {candidat.dispo || 'N/A'}</span>
        <span className="flex items-center gap-1"><HiOutlineBanknotes /> {candidat.salaireActuel || 'N/A'}</span>
        <span className="flex items-center gap-1"><HiOutlineMapPin /> {candidat.mobilite || 'N/A'}</span>
        <span className="flex items-center gap-1 col-span-2"><HiOutlineBuildingOffice2 /> Client : {candidat.ps || 'N/A'}</span>
      </div>
    </div>
  );
};

export default CandidateCard;
